export const trackPixel = (event, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', event, params);
    }
  } catch (e) {
    console.debug('Meta Pixel track failed', e);
  }
};
